import OnePropApp from './components/OnePropApp.jsx';
import { AuthProvider } from './components/session.jsx';
import { ToastProvider } from './components/ui.jsx';

// Providers shared by every page: toast messages and the signed-in session.
export default function App() {
  return <ToastProvider><AuthProvider><OnePropApp /></AuthProvider></ToastProvider>;
}
